module.exports = __webpack_public_path__ + "static/media/allgaier-tumbler-sito-s.31f8a968.webp";